import React, { useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { RelatedSearchTypes } from '../../../types';
import { fetchRelatedSearchTerms } from '../../../service/relatedSearchTerms';
import { AppContext } from '../../context/listingsContext';
import SearchTags from './SearchTags';
import './index.scss';

const RelatedSearch = ({ displayData }) => {

    const [relatedTerms, setRelatedTerms] = useState([]);

    useEffect(() => {
        const { searchComponentData: { relatedTermsUrl } } = displayData;
        return fetchRelatedSearchTerms(relatedTermsUrl)
            .then((relatedTerms) => setRelatedTerms(relatedTerms));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { isTouch } = useContext(AppContext);
    const hasSearchTags = relatedTerms.length !== 0;

    return (
        <header className="related-search">
            <nav className={classNames('row', { 'scrollable-related-links': isTouch })}>
                {hasSearchTags &&
                <React.Fragment>
                    {!isTouch && <b><I18n k="search_perseus.related_search.suggested"/></b>}
                    <SearchTags relatedTerms={relatedTerms}/>
                </React.Fragment>
                }
            </nav>
        </header>
    );
};

RelatedSearch.propTypes = RelatedSearchTypes;

export default RelatedSearch;
